import { useGetUsersQuery } from "./usersApiSlice"
import User from './User'
import useTitle from "../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowsV, faUserPlus } from "@fortawesome/free-solid-svg-icons"
import { Link, useNavigate, useParams } from "react-router-dom"
const UsersList = ({txt, filterGroup}) => {
    const {groupId, type} = useParams()
    useTitle('geshtop-Exercise: Users List')
    const navigate = useNavigate()
    const {
        data: users,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetUsersQuery('usersList', {
        // pollingInterval: 60000,
        // refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    })

    let content

    if (isLoading) content = <PulseLoader color={"#FFF"} />

    if (isError) {
        content = <p className="errmsg">{error?.data?.message}</p>
    }

    if (isSuccess) {

        const { ids , entities} = users
        let newIds=[] 

        if(txt || groupId !== '0'){
             newIds =  ids.filter(id=>{
                const user = entities[id]
                    if( (txt==='' || (user.name.toLowerCase().indexOf(txt) > -1 
                        || user.email.toLowerCase().indexOf(txt) > -1
                        || user.username.toLowerCase().indexOf(txt) > -1
                        || user.phone.toLowerCase().indexOf(txt) > -1
                        )) && (groupId ==='0' ||  user.groups?.includes(groupId)))
                        return id
                })
            }
            else{
                newIds=[...ids]
            }
        const tableContent = newIds?.length && newIds.map((userId, inx) => <User inx={inx} key={userId} userId={userId} />)

        content = (
            <>
     
   
    
    <section className="list__action-buttons">
    <Link to={`/${type}/${groupId}/users/new`}>
 <FontAwesomeIcon icon={faUserPlus} /> New User
        </Link>
        <Link to={`/${type}/${groupId}/users/edit-groups`}>
 <FontAwesomeIcon icon={faArrowsV} /> Edit groups
        </Link>

        </section>

            <table className="table table--users">
                <thead className="table__thead">
                    <tr>
                        <th scope="col" className="table__th user__username">Username</th>
                        <th scope="col" className="table__th user__name">שם</th>
                        <th scope="col" className="table__th user__email">מייל</th>
                        <th scope="col" className="table__th user__phone">טלפון</th>
                        {/* <th scope="col" className="table__th user__groups">קבוצות</th>                       */}
                        <th scope="col" className="table__th user__roles">Roles</th>
                        <th scope="col" className="table__th user__edit">#</th>
                    </tr>
                </thead>
                <tbody>
                    {tableContent}
                </tbody>
            </table>
            </>
        )
    }

    return content
}
export default UsersList